<template>
    <div>
      <header-nav :cur="4" />
      <div class="nav">
        <div class="navtab">
                <span class="top">
                    <span @click="toIndex()" style="cursor:pointer"  >首页</span>&nbsp;>
                    <span class="infor">关于</span>
                </span>
          <div class="newbox">
            <div>
              <div class="newtop">关于我们</div>
              <div class="newbot">在这里可以更详细的了解我们！</div>
            </div>
<!--            <div class="input">-->
<!--              <input placeholder="请输入搜索关键字" type="text"/>-->
<!--              <div class="select">搜索</div>-->
<!--            </div>-->
          </div>
        </div>
      </div>
      <div class="content" v-html="key" style="font-size: 0.2963rem;height:460px">

      </div>
    <footer-nav />
    </div>
</template>

<script>
import headerNav from '../../components/HeaderNav.vue';
import footerNav from '../../components/FooterBar';
export default {
    components: {
        headerNav,
        footerNav,
    },
	data() {
		return {
			key: "<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;兰州文理学院是2013年经教育部批准设立的普通本科院校。其前身是1950年创立的甘肃教育学院和1985年创办的甘肃联合大学，2011年甘肃省艺术学校并入。学校是甘肃省首批转型发展试点院校，教育部确定的中国传媒大学对口支援西部高校，文旅部非遗传承人群研修基地，首届“甘肃省文明校园”，新时代甘肃省高校党建“示范院校”。</p>"
			  + "<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;按照省委、省政府确定的“建设一批服务文化大省建设的学科专业、培养一批服务文化大省建设的应用型人才、形成一批服务文化大省建设的理论成果”的指示，确立了“优化 结构、强化特色、突出应用、提高质量”的办学方针。</p>"

		}
	},
	methods:{
		toIndex(){
			this.$router.push('/');
		},
	}
};
</script>

<style lang="less" scoped>
    // 公共
    .navtab {
      width: 1280px;
      margin: 0 auto;
    }

    .color {
      color: #2961EF !important;
    }

    .ignore {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
    }

    // 搜索
    .nav {
      background: #f7f8fa;
      width: 100%;
      height: 177px;

      .top {
        display: block;
        font-size: 16px;

        font-weight: 300;
        color: #777777;
        padding: 19px 0 24px;

        .infor {
          color: #2961EF;
        }
      }

      .newbox {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .newtop {
          font-size: 26px;
          color: #000000;
          margin-bottom: 5px;
        }

        .newbot {
          font-size: 16px;
          color: #888888;
        }

        .input {
          width: 497px;
          height: 59px;
          background: #ffffff;
          box-shadow: 3px 3px 10px 1px rgba(11, 19, 72, 0.050980392156862744);
          border-radius: 30px;
          position: relative;

          input {
            border: none;
            position: absolute;
            left: 30px;
            top: 0;
            height: 59px;
            line-height: 59px;
            width: 365px;
            font-size: 16px;

            font-weight: 300;
            color: #777777;
          }

          .select {
            position: absolute;
            right: 12px;
            top: 8px;
            width: 74px;
            height: 43px;
            line-height: 43px;
            background: #2961EF;
            border-radius: 30px;
            font-size: 16px;

            font-weight: 300;
            color: #ffffff;
            text-align: center;
          }
        }
      }
    }

    // 学科分类
    .bacground {
      background: #f7f8fa;
    }

    .type {
      margin: 0 0 20px 0;
      padding: 14px 17px;

      border-radius: 5px 5px;
      border: 1px solid #e3e8f2;

      .ul {
        font-size: 16px;
        color: #333333;
        display: inline-block;
        vertical-align: text-top;
        width: 7%;
        margin-top: 3px;
      }

      ul {
        display: inline-block;
        vertical-align: text-top;
        // float: right;
        width: 93%;

        li {
          display: inline-block;
          font-size: 16px;
          color: #888888;
          margin-right: 30px;
          line-height: 30px;

        }
      }

      .add {
        margin-top: 15px;
      }

      .addul {
        margin-top: 18px;
      }
    }

    .brder {
      border-top: none;
      margin: 0 0 21px;
      border-radius: 0px 0px 0px 0px;

      .ul {
        margin-top: 3px;
      }

      .add {
        margin: 0;
      }
    }

    // 学科列表
    .listbox {
      padding: 11px;
      display: inline-block;
      align-items: center;
      background: #f7f8fa;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 28px;
      border-radius: 5px;
      border: 1px solid #e3e8f2;

      .secodebox {
        cursor: pointer;
        display: flex;
      }

      img {
        width: 220px;
        height: 140px;
        vertical-align: middle;
        margin-right: 20px;
      }

      .title {
        font-size: 20px;
        color: #333333;
        font-weight: 400;

        span {
          padding: 3px 14px;
          font-size: 14px;
          border-radius: 5px 5px 5px 5px;
        }

        .color1 {
          border: 1px solid #b4d4f8;
          color: #2961EF;
          background: rgba(180, 212, 248, 0.5);
          margin: 0 7px 0 16px;
        }

        .color2 {
          border: 1px solid #f8d1b4;
          color: #ff6c00;
          background: rgba(248, 209, 180, 0.5);
        }
      }

      .time {
        display: inline-block;
        font-size: 14px;
        color: #888888;
        position: relative;
        margin: 10px 0 14px;

        span {
          vertical-align: middle;
          padding: 0 20px;
          height: 10px;
          border-right: 1px solid rgba(119, 119, 119, 0.82);
          // &::after {
          //     content: '';
          //     height: 18px;
          //     width: 1px;
          //     position: absolute;
          //     right: 10px;
          //     top: 0;
          // }
          &:nth-child(1) {
            padding: 0 20px 0 0;
          }

          &:nth-child(3) {
            border-right: none;
          }
        }
      }

      .tent {
        font-size: 14px;
        font-weight: 300;
        color: #777777;
        width: 760px;
        text-indent: 2em;
      }

      .bottom {
        font-size: 25px;
        color: #2961EF;
        text-align: center;
        margin: 0 28px 0 75px;

        .butten {
          cursor: pointer;
          width: 130px;
          height: 37px;
          line-height: 37px;
          background: #2961EF;
          border-radius: 24px 24px 24px 24px;
          text-align: center;
          font-size: 16px;
          color: rgba(255, 255, 255, 1);
          margin: 27px auto 0;

          img {
            width: 19px;
            height: 19px;
            margin-right: 5px;
          }
        }
      }
    }


    //学科简介
    .xkjj {
      width: 1280px;
      height: auto;
      padding:10px 25px 25px 25px;
      box-sizing: border-box;
      display: block;
      margin: 25px auto;
      border: 5px solid #2961EF;
      border-radius: 10px;
      background: #f3f6ff;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .title {
        width: 100%;
        line-height: 40px;
        font-weight: bold;
        font-size: 18px;
        color: #2961EF;
        margin-bottom: 10px;
      }
      img{
        width: 350px;
        height: 220px;
        margin-right: 20px;
        display: inline-block;
      }
      .xkjj_cont{
        width: calc(100% - 370px);
        height: 220px;
        overflow-y: auto;
        display: inline-block;
        p{
          width: 100%; height: auto; line-height: 31px; font-size: 16px; color: #666; text-indent: 2em;
          margin-bottom: 8px;
        }
      }
    }
    .content{
      width: 1280px;
      height: auto;
      display: block;
      margin: 40px auto;
      p{
        width: 100%;
        height: auto;
        line-height: 30px;
        font-size: 16px;
        color: #666;
        margin-top: 12px;
        text-indent: 2em;
      }
    }


</style>
